import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DPO_CONSTANT } from './../utils/constant';
import { AppConfig } from '../modules/app.config';  //CAP-20753(SGP Zone): Imported AppConfig file for Client related Changes

// HTTP Service to intract with actual HTTP client provided by Angular to call backend API endpoints.
@Injectable()
export class HttpService {

    domain: string;   //CAP-20753(SGP Zone): Added domain for Client related Changes
    constructor(private http: HttpClient, private router: Router, private apiconfig :AppConfig) {   //CAP-20753: Added AppConfig file in Constructor for Client related Changes

        //CAP-20753(SGP Zone): START: Condition for Client related Changes
        var apiPath='';
        if(this.apiconfig.mpsaFlag==='N'){
            apiPath = this.apiconfig.apiUrl + this.apiconfig.apiPath;
        } else {
            apiPath = this.apiconfig.apiPath;
        }

        this.domain = apiPath;
        //CAP-20753(SGP Zone): STOP -Condition for Client related Changes
     }

    // Method to call a GET request
    public get(url: string, options?: any) {
        const finalURL = this.domain + url;   //CAP-20753: Added domain for Client related Changes
        return this.http.get(finalURL, options);
    }

    //CAP-20457: LOT1.1: START - Translation http Service changed to translate for JSON
    public getpath(path: any, options?: any) {

        options = {
            headers: {
                accept: 'application/json'
            },
            responseType: 'json'
        }
        return this.http.get(path, options);
    }
    //CAP-20457: LOT1.1: STOP - Translation http Service changed to translate for JSON

    // Method to call a POST request
    public post(url: string, body: any, options?: any) {
        const finalURL = this.domain + url;    //CAP-20753: Added domain for Client related Changes
        return this.http.post(finalURL, body, options);
    }

    // Method to call a PUT request
    public put(url: string, body: any, options?: any) {
        const finalURL = this.domain + url;    //CAP-20753: Added domain for Client related Changes
        return this.http.put(finalURL, body, options);
    }

    // Method to prepare query parameter string
    public prepareQueryParams(params: any): string {
        let queryParams = '?';
        for (const key in params) {
            if (params[key]) {
                let value = params[key]
                queryParams += key + '=' + value + '&';
            }
        }
        queryParams = queryParams.substring(0, (queryParams.length - 1));
        return queryParams;
    }

    // Method to get query parameter from query parameter string
    public getUrlQueryParams(url: string): any {
        let params: any = undefined;
        let queryParamString = this.router.url.split('?')[1];
        if (queryParamString) {
            params = {};
            let queryParams = queryParamString.split('&');
            queryParams.forEach(param => {
                let obj = param.split('=');
                let key = obj[0];
                let value = obj[1];
                if (key && value) {
                    params[key] = value;
                }
            });
        }
        return params
    }

    // Method to call a GET request for i18n excel files only
    public getCallForI18nFile(url: string, options?: any) {
        const finalURL = DPO_CONSTANT.I18N_ENDPOINT + url;
        options = {
            headers: {
                accept: 'application/vnd.ms-excel'
            },
            responseType: 'arraybuffer'
        }
        return this.http.get(finalURL, options);
    }

    // Method to call a GET request for Token API only
    public getCallForToken(url: string, token: any) {
         
        let finalURL = this.domain + url;  //CAP-20753: Added domain for Client related Changes
        
        
        let options = {
            headers: {
                AuthorizationToken: token
            }
        }
        return this.http.get(finalURL, options);
    }

    //START - CAP_20753:PART-2: POI BASEAUTH - HEADER EXTRACTION
    public getBaseAuth(url: string, headerParams: any) {

        let finalURL = this.domain + url; 
        let options = {
            headers: {
                Authorization: headerParams
            }
        }

        return this.http.get(finalURL, options);

    }
    //STOP - CAP_20753:PART-2: POI BASEAUTH - HEADER EXTRACTION

}